import React, { useRef } from "react";
import styled from "@emotion/styled";
import Header from "./Intro/Header";
import Clouds from "./Broll/Clouds";
import Intro from "./Intro/Intro";
import Broll from "./Broll/Broll";
import Background from "./Background/Background.js";
import How from "./How/How.js";

import { useIntersection } from "react-use";
import gsap from "gsap";
import Demo from "./demo/Demo";
import Reflection from "./Conclusion/Reflection";

import demo25Video from "./demo/demo25Small.mp4";
import demo100Video from "./demo/demo100Small.mp4";
import demo200Video from "./demo/demo200Small.mp4";
import demo500Video from "./demo/demo500Small.mp4";
import environment from "./imgs/environmentWith.png";

import "./App.css";
import TrackVisibility from "react-on-screen";

function App() {
  const Card = styled.div`
    height: 100vh;
    padding: 30px 10%;
    box-sizing: border-box;
    min-width: 1200px;
    position: relative;
    z-index: 5;
    margin-bottom: 5%;
    min-height: 700px;

    @media (max-width: 1100px) {
      height: auto;
      min-width: 0;
      min-height: 0;
    }
  `;

  const ConclusionCard = styled.div`
    padding: 30px 10%;
    box-sizing: border-box;
    min-width: 1200px;
    position: relative;
    z-index: 5;
    margin-bottom: 5vh;
    height: 80vh;

    @media (max-width: 1100px) {
      height: auto;
      min-width: 0;
    }
  `;

  // text for the demos
  const demo25Text = `
  At just 25 iterations, it’s not enough for the AI to know how to drive yet. It is able to accelerate and just drive straight through the intersection regardless of the traffic light. It has not learned to turn left yet. However, the AI demonstrates it can stay in the lane without swerving.
  `;

  const demo100Text = `
  At 100 iterations, the AI knows when to stop most of the time, turn at the intersection, and will even stay in the lane correctly until it has made the turn; in which case the AI often drives on the lines. The AI has been shown to turn even if there are cars coming through the intersection.
  `;

  const demo200Text = `
  At 200 iterations, the AI is near perfect and knows exactly when to stop and go. It knows the exact distance it’ll take to stop at that speed and makes its moves effectively. Interaction with the traffic lights are also correct.
  `;

  const demo500Text = `
  At 500 iterations, the AI is almost identical to its 200 iteration predecessor in terms of avoiding traffic and knowing when to stop. It seems at 500 iterations the AI is much better at staying in the lanes and not driving on the lines after it has made the turn.
  `;

  return (
    <>
      <Card className="introCard" style={{ backgroundColor: "#191919" }}>
        <div className="bgCard"></div>
        <Header />
        <Intro />
      </Card>
      {/* <Card> */}
      {/* <Broll /> */}
      {/* <Clouds y={5}></Clouds> */}
      {/* <Clouds y={35}></Clouds> */}
      {/* <Clouds y={50}></Clouds> */}
      {/* </Card> */}

      <Card>
        <TrackVisibility partialVisibility>
          <Background />
        </TrackVisibility>
      </Card>

      <Card>
        <TrackVisibility partialVisibility>
          <How />
        </TrackVisibility>
      </Card>

      <Card className="">
        <TrackVisibility partialVisibility>
          <Demo video={demo25Video} text={demo25Text} title={"25 Iterations"} />
        </TrackVisibility>
      </Card>

      <Card className="">
        <TrackVisibility partialVisibility>
          <Demo
            video={demo100Video}
            text={demo100Text}
            title={"100 Iterations"}
          />
        </TrackVisibility>
      </Card>

      <Card className="">
        <TrackVisibility partialVisibility>
          <Demo
            video={demo200Video}
            text={demo200Text}
            title={"200 Iterations"}
          />
        </TrackVisibility>
      </Card>

      <Card className="">
        <TrackVisibility partialVisibility>
          <Demo
            video={demo500Video}
            text={demo500Text}
            title={"500 Iterations"}
          />
        </TrackVisibility>
      </Card>

      <ConclusionCard style={{}}>
        <TrackVisibility>
          <Reflection />
        </TrackVisibility>
      </ConclusionCard>
    </>
  );
}

export default App;
